import React from "react";
import { SegmentController } from "components/designV2/segmentcontroller/segmentcontroller";
import { Dropdown } from "components/designV2/dropdown/dropdown";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { GigType } from "model/Gig";
import { useTranslation } from "react-i18next";
import {
  TabsContainer,
  TabsRow,
  VisibleForDropdownWrap,
} from "../createGigModal.styled";
import type { FormData, Tab } from "./gigFormModal.types";

type Props = {
  canRecruit: boolean;
  tab: Tab;
  isLoading: boolean;
  havePublicModule: boolean;
  haveTeamModule: boolean;
  visibleForValue: GigType.PUBLIC | GigType.WORKPOOL;
  requestTabChange: (to: Tab) => void;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
};

export const GigFormTabs: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const {
    canRecruit,
    tab,
    isLoading,
    havePublicModule,
    haveTeamModule,
    visibleForValue,
    requestTabChange,
    setFormData,
  } = props;

  if (!canRecruit) {
    return null;
  }

  return (
    <TabsContainer>
      <TabsRow>
        <SegmentController<"Schedule" | "Recruit">
          options={[
            { value: "Schedule", label: t("CreateShift.Schedule") },
            { value: "Recruit", label: t("CreateShift.Recruit") },
          ]}
          value={tab}
          tone="dark"
          disabled={isLoading}
          onChange={requestTabChange}
        />
        {tab === "Recruit" && (
          <>
            <Text typography="s1" color={ColorV2.Blue4}>
              {t("CreateShift.VisibleFor")}
            </Text>
            {havePublicModule && haveTeamModule && (
              <VisibleForDropdownWrap>
                <Dropdown
                  options={[
                    {
                      value: GigType.WORKPOOL,
                      label: t("CreateShift.Team"),
                    },
                    {
                      value: GigType.PUBLIC,
                      label: t("CreateShift.Public"),
                    },
                  ]}
                  value={visibleForValue}
                  placeholder={t("CreateShift.Team")}
                  fullWidth
                  disabled={isLoading}
                  onChange={(value) => {
                    if (
                      value !== GigType.WORKPOOL &&
                      value !== GigType.PUBLIC
                    ) {
                      return;
                    }
                    setFormData((previousFormData) => ({
                      ...previousFormData,
                      type: value,
                    }));
                  }}
                />
              </VisibleForDropdownWrap>
            )}
          </>
        )}
      </TabsRow>
    </TabsContainer>
  );
};
